import { render, staticRenderFns } from "./video_search.vue?vue&type=template&id=4ea2d1f2&"
import script from "./video_search.vue?vue&type=script&lang=js&"
export * from "./video_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports